import { Button } from '@grofers/react';
import React from 'react';
import { useState } from 'react';
import { useTestTatPolicyFields, useEvaluateTatPolicy } from '../apis';
import { grey } from 'sushiweb/tokens/color';
import Spinner from 'sushiweb/Spinner/Spinner';
import { Star } from '../../../UiKit/Star/Star';
import { Dropdown } from '../../../UiKit';

function TestTatPolicy() {
  const [namespaces, setNamespaces] = useState([]);
  const [namespace, setNamespace] = useState('');
  const [ctypes, setCTypes] = useState([]);
  const [ctype, setCType] = useState('');
  const [tatResponse, setTatResponse] = useState({});
  const { isLoading } = useTestTatPolicyFields({
    onSuccess: (response) => {
      setNamespaces(response?.namespaces);
      setCTypes(response?.ctypes);
    },
  });

  const { mutate: evaluatePolicy, isLoading: isTestLoading } =
    useEvaluateTatPolicy({
      onSuccess: (response) => setTatResponse(response),
    });

  const handleSubmit = (event) => {
    event.preventDefault();
    setTatResponse({});
    const dataToSubmit = {
      attributes: {
        item_category: event.target.item_category.value,
        item_ptype: event.target.item_ptype.value,
        item_brand: event.target.item_brand.value,
        item_tag: event.target.item_tag.value,
        order_tag: event.target.order_tag.value,
        customer_karma: event.target.customer_karma.value,
      },
      ctype: ctype,
      namespace: namespace,
    };
    evaluatePolicy(dataToSubmit);
  };

  const getNamespaceDropDownValues = () => {
    let dropdownValues = {};
    if (namespaces?.data) {
      namespaces?.data.forEach((element) => {
        dropdownValues = {
          ...dropdownValues,
          [element]: element,
        };
      });
    }
    return dropdownValues;
  };

  const getCtypesDropDownValues = () => {
    return ctypes?.data;
  };

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-h-max'>
      <form
        className='tw-w-full tw-flex tw-flex-col tw-h-max tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl'
        onSubmit={handleSubmit}
      >
        <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
          {getTextField(
            'item_category',
            'Item Categories',
            'Enter semicolon ; separated item categories',
          )}

          {getTextField(
            'item_ptype',
            'Product Type',
            'Enter item product type',
          )}
        </div>

        <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
          {getTextField('item_brand', 'Item Brand', 'Enter item brand')}

          {getTextField(
            'item_tag',
            'Item Tags',
            'Enter semicolon ; separated tags',
          )}

          {getTextField(
            'order_tag',
            'Order Tags',
            'Enter semicolon ; separated tags',
          )}

          {getTextField(
            'customer_karma',
            'Customer Karma Score',
            'Enter karma score',
          )}
        </div>

        <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
          <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-2'>
            <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500'>
              Namespace <Star icon='*' />
            </div>
            <Dropdown
              placeholder={'Select policy namespace'}
              onSelect={(value) => setNamespace(value)}
              dropdownVal={namespace}
              dropDownValues={getNamespaceDropDownValues()}
            />
          </div>
          <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-2'>
            <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500'>
              Complaint Type <Star icon='*' />
            </div>
            <Dropdown
              placeholder={'Select complaint type'}
              onSelect={(value) => setCType(value)}
              dropdownVal={ctype}
              dropDownValues={getCtypesDropDownValues()}
            />
          </div>
        </div>

        <Button variant={'fill'} className='tw-h-16 tw-w-32'>
          {isLoading || isTestLoading ? (
            <Spinner size='small' color={`${grey.z300}`} />
          ) : (
            'Evaluate'
          )}
        </Button>
      </form>

      {tatResponse?.success && (
        <div className='tw-w-full tw-flex tw-flex-col tw-h-max tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl tw-mt-16 tw-font-medium'>
          {tatResponse.found
            ? '⏱️ TAT is found to be ' + tatResponse.tat
            : '🤷🏻 No tat policy found'}
        </div>
      )}

      {'success' in tatResponse && !tatResponse.success && (
        <div className='tw-w-full tw-flex tw-flex-col tw-h-max tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl tw-mt-16 tw-font-medium'>
          ❌ TAT could not be found due to a technical error. Please try again.
        </div>
      )}
    </div>
  );
}

const getTextField = (name, title, placeholder) => {
  return (
    <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
      <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500'>
        {title}
      </div>
      <div className='tw-flex tw-flex-col tw-w-full'>
        <input
          id={name}
          name={name}
          placeholder={placeholder}
          className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full
          'focus:tw-ring-green-500 focus:tw-border-green-500' tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
          autoComplete='off'
        />
      </div>
    </div>
  );
};

export default TestTatPolicy;
